import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import {
  STATE_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
} from "./constants";

const { EMERGENCY_USER_LIST, DETAIL, USER, CALL_STATE } = STATE_IDENTIFIER;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [EMERGENCY_USER_LIST]: {
    [LIST_IDENTIFIER]: [],
    [LOADER_IDENTIFIER]: false,
  },
  [DETAIL]: {
    [USER]: {},
    [CALL_STATE]: IResponseState.PENDING,
  },
};
